{
  "optionsBoard": {
    "errors": {
      "couldNotGetOptions": "Не удалось получить опционы"
    }
  }
}
